
// Optional: Add custom labels for certain paths


import { useLocation, Link } from "react-router-dom";
import { useMemo } from "react";

// Human-friendly labels
const breadcrumbNameMap = {
    dashboard: "Dashboard ",
    Membership: "Membership",
    MembershipForm: "Membership Form",
    Profile: "My Profile",
    Business_impact: "Business Impact",
    Businessimpact: "Business Wallet",
    new_request: "New Request",
    sent_request: "Sent Request",
    receive_request: "Receive Request",
    accept_request: "Accept Request",
    member: "Members",
    Timeline: "Timeline",
    user: "User Directory",
    news: "All News",
    newsArticle: "News Article",
    photosgallery: "Photo Gallery",
    albumCard: "Albums",
    albumsgallery: "Albums Gallery",
    videosgallery: "Videos",
    EventsMenu: "Event Menu",
    EventsCards: "Event Cards",
    Events: "Events",
    certificates: "Certificates",
    OtherProfile: "Other Member Profile",
    Chat: "Chat",
    recentMember: "Recent Members"
  };

const Breadcrumbs = () => {
  const location = useLocation();

  const currentPathnames = location.pathname.split("/").filter(Boolean);
  const fromPath = location.state?.from?.split("/").filter(Boolean) || [];

  const breadcrumbs = useMemo(() => {
    const items = [];

    // Always start with Home
    items.push({ label: "Home", to: "/dashboard" });

    // If there's a "from" route, add its parts
    for (let i = 0; i < fromPath.length; i++) {
      const part = fromPath[i];
      const to = "/" + fromPath.slice(0, i + 1).join("/");
      items.push({ label: breadcrumbNameMap[part] || part, to });
    }

    // Add current route parts
    for (let i = 0; i < currentPathnames.length; i++) {
      const part = currentPathnames[i];
      const to = "/" + currentPathnames.slice(0, i + 1).join("/");
      items.push({
        label: breadcrumbNameMap[part] || part,
        to,
        isLast: i === currentPathnames.length - 1,
      });
    }

    return items;
  }, [location]);

  return (
    <nav aria-label="breadcrumb" className="breadcrumb-container">
      <ol className="breadcrumb">
        {breadcrumbs.map(({ label, to }, idx) => {
          const isLast = idx === breadcrumbs.length - 1;
          return (
            <li
              key={to}
              className={`breadcrumb-item ${isLast ? "active" : ""}`}
              {...(isLast && { "aria-current": "page" })}
            >
              {isLast ? label : <Link to={to}>{label}</Link>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;

